import type {
    AtribuirFaixasDistanciaModel,
    FaixaDistancia,
} from "../models/atribuirFaixasDistanciaModel"

export enum AtribuirFaixasDistanciaActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR_FAIXA = "ADICIONAR_FAIXA",
    ATUALIZAR_FAIXA = "ATUALIZAR_FAIXA",
    REMOVER_FAIXA = "REMOVER_FAIXA",
}

export type AtribuirFaixasDistanciaActionModel =
    | {
          type: AtribuirFaixasDistanciaActionsTypes.CARREGAR
          payload: AtribuirFaixasDistanciaModel
      }
    | {
          type: AtribuirFaixasDistanciaActionsTypes.ADICIONAR_FAIXA
      }
    | {
          type: AtribuirFaixasDistanciaActionsTypes.ATUALIZAR_FAIXA
          payload: { index: number; campo: keyof FaixaDistancia; valor: string | null }
      }
    | {
          type: AtribuirFaixasDistanciaActionsTypes.REMOVER_FAIXA
          payload: { index: number }
      }
